<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <FrotaSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import FrotaSettingsList from '@/components/settings/FrotaSettingsList'

  export default {
    name: 'FrotaSettings',
    components: {
      PageTitle,
      PageRowWrapper,
      FrotaSettingsList
    }
  }
</script>
